namespace JupitersChoice {
    export class CheckMegaHitCmd {

        @inject('BetModel') _betModel: Sapphire.BetModel;
        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;
        @inject('ResponseHelper') _responseHelper: ResponseHelper;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;
        @inject('StateModel') _stateModel: Sapphire.StateModel;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            const spinInfo = this._stateModel.currentSubgame === 'FreeGame' ?
                response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1] : response;
            const megaHitBackground = this._componentManager.get('MegahitBackground');
            const megaHitLogo = this._componentManager.get('MegahitLogo');
            const megaHitWipe = this._componentManager.get('WipeFlare');

            if (!this._responseHelper.hasMegaHit(spinInfo.winnings)) {
                this._eventManager.publish('onHasNoMegaHit');
            } else {
                TweenMax.delayedCall(2, () => {
                    this._layerManager.setVisibility('Megahit', true);

                    // initially hide background + logo
                    this._componentManager.hideComponents(['MegahitBackground', 'MegahitLogo']);

                    // update spine animation state
                    megaHitBackground.changeAnimation('megahit_bg_loop', false, true);

                    // Fade in background + logo
                    megaHitLogo.fadeIn(1);
                    megaHitBackground.fadeIn(1);
                    megaHitLogo.scale.x = 0;
                    megaHitLogo.scale.y = 0;
                    TweenMax.to(megaHitLogo.scale, 1, {
                        x: 1,
                        y: 1,
                        ease: Quart.easeOut
                    });
                    this._soundManager.play('lightning_02', null, AudioConstants.MEGAHIT_LIGHTNING_VOLUME);

                    TweenMax.delayedCall(1, () => {
                        this._soundManager.play('vo_jupiter_mega_win');
                        this._soundManager.play('vo_jupiter_mega_win', null, 0.5);
                    });
                    TweenMax.delayedCall(2, () => {
                        this._soundManager.play('lightning_02', null, AudioConstants.MEGAHIT_LIGHTNING_VOLUME);
                        this._soundManager.play('vo_jupiter_mega_laugh');
                    });


                    TweenMax.delayedCall(3, () => {

                        megaHitWipe.play(() => {
                            megaHitBackground.changeAnimation('megahit_bg_loop', false, false);
                            megaHitLogo.hide();
                            megaHitBackground.hide();
                        }, () => {
                            this._layerManager.setVisibility('Megahit', false);
                            this._eventManager.publish('onMegaHitComplete');
                        });                        
                    });
                });
            }
        }
    }
}